export function getJiraURL(): string {
  return `https://nbdevs.atlassian.net`;
}

export function getJiraProjectURL(jiraKey: string): string {
  return `${getJiraURL()}/browse/${jiraKey}`;
}
